export default "__VITE_ASSET__0838d70b__"